'use strict'

export function isIphoneX() {
  return /iphone/gi.test(navigator.userAgent) && ((screen.height == 812 && screen.width == 375) || (screen.height == 896 && screen.width == 414))
}

export function isWeibo () {
  const isWeibo = !!u.match(/WeiBo/i)
  return isWeibo
}

export function isQQ () {
  const isQQ = !!u.match(/QQ\//i)
  return isQQ
}

export function isMobile () {
  const isMobile = !!u.match(/AppleWebKit.*Mobile.*/)
  return isMobile
}

export function getScrollTop () {
  var scrollTop = 0, bodyScrollTop = 0, documentScrollTop = 0
　if (document.body) {
　  bodyScrollTop = document.body.scrollTop
　}
　if (document.documentElement) {
　  documentScrollTop = document.documentElement.scrollTop
　}
　scrollTop = (bodyScrollTop - documentScrollTop > 0) ? bodyScrollTop : documentScrollTop
　return scrollTop
}

export function getScrollHeight () {
  var scrollHeight = 0, bodyScrollHeight = 0, documentScrollHeight = 0
  if(document.body){
    bodyScrollHeight = document.body.scrollHeight
　}
　if(document.documentElement){
    documentScrollHeight = document.documentElement.scrollHeight
　}
　scrollHeight = (bodyScrollHeight - documentScrollHeight > 0) ? bodyScrollHeight : documentScrollHeight
　return scrollHeight
}

export function getWindowHeight () {
  var windowHeight = 0
  if(document.compatMode == "CSS1Compat"){
    windowHeight = document.documentElement.clientHeight
  }else{
    windowHeight = document.body.clientHeight
  }
  return windowHeight
}

export function formatMultiNum (num) {
  if(!num) {
    return 0
  } else {
    const numArr = num.toString().split(".")
    const intNum = numArr.length>1 ? numArr[1] : numArr[0]
    const reverseNums = intNum.split("").reverse()
    const len = reverseNums.length
    let newNums = []

    reverseNums.forEach((n, index) => {
      if((index+1)%3 === 0) {
        newNums.push(n)
        if(index+1 !== len) {
          newNums.push(",")
        }
      } else {
        newNums.push(n)
      }
    })

    return newNums.reverse().join("")
  }
}

export function zipImage (image, zipWidth) {
  if(!image || !image.src) {
    return ''
  }

  const baseWidth = 750
  let src = ''
  let newSrc = ''
  if(typeof image === 'string') {
    src = image
    const width = zipWidth || baseWidth
    newSrc = formatZipImage(src, width)
    return newSrc
  }

  if(typeof image === 'object') {
    src = image.src
    const imageWidth = image.width
    const myWidth = imageWidth<baseWidth?imageWidth:baseWidth
    const width = zipWidth || myWidth
    newSrc = formatZipImage(src, width)
    return {
      src: newSrc,
      width: image.width,
      height: image.height
    }
  }
  
  return image
}

export function wxFormatProductList (productsItem, products, increase) {
  const tempProductGroup = []
  let isLeft = false // 左右标记
  let isInit = false // 每一轮商品初始化
  let singleProduct = null // 给上一页最后一个空位置预留
  productsItem.forEach((prod, index) => {
    let {
      id,
      sceneImage,
      sceneVideo,
      sceneCover,
      cropListImage,
      cropFeatureImage,
      featureImage,
      price,
      rawPrice,
      refunds,
      activityDesc,
      customizable,
      foretell,
      mainStationFirst,
      name,
      newcomerTag,
      offShelf,
      priceForecast,
      refundsName,
      summary,
      stockWarn,
      soldOut,
      labels,
      copywriter,
      isOversea,
      rush,
      deliveryTag
    } = prod

    const newProd = {
      id,
      sceneImage,
      cropFeatureImage,
      cropListImage,
      featureImage,
      price,
      rawPrice,
      refunds,
      activityDesc,
      customizable,
      foretell,
      mainStationFirst,
      name,
      newcomerTag,
      offShelf,
      priceForecast,
      refundsName,
      summary,
      stockWarn,
      soldOut,
      labels,
      copywriter,
      isOversea,
      sceneImage,
      sceneVideo,
      sceneCover,
      rush,
      deliveryTag
    }
    // 处理一些prod细节
    newProd._cropListImage = formatZipListImage(cropListImage || cropFeatureImage || featureImage)
    if (refunds) {
      newProd._refunds = refunds.toFixed(1)
    }
    newProd._index = increase * 10 + index
    // 处理一些prod细节结束
    let _tempProduct = null // 这事有sceneImage的商品对象
    if (sceneImage || sceneVideo) {
      _tempProduct = Object.assign({
        _isScene: true
      }, newProd)
    }

    if (!isInit && products.length && !products[products.length - 1][1]) {// 每次分页时上一页最后一组商品是单个的
      singleProduct = productsItem.filter(p => {  //获取每次分页的新一轮商品中第一个不带sceneImage的商品
        return !p.sceneImage && !p.sceneVideo
      })[0]
      isInit = true
    }

    if (singleProduct && singleProduct.id === newProd.id) { // 分页的商品不处理已经补足上一页最后一组为单数的商品
      singleProduct = newProd
      return
    } 
    
    if (!tempProductGroup.length) { // 每一轮开始的判断
      const _newArr = new Array(2)
      _newArr[0] = newProd
      if (_tempProduct) {
        _newArr[1] = _tempProduct
        isLeft = true
      }
      tempProductGroup.push(_newArr)

      return 
    }

    const prevLastGroupProduct = tempProductGroup[tempProductGroup.length - 1] // 取最后一组数据
    const prevLastPos = prevLastGroupProduct[1] // 上一组最后一个数据

    if (_tempProduct && !prevLastPos) { // 是sceneImage && 上一个最后一组数据是单数
      if (isLeft) {
        tempProductGroup[tempProductGroup.length - 1] = [_tempProduct, newProd]
        isLeft = false
      }
      else {
        tempProductGroup[tempProductGroup.length - 1] = [newProd, _tempProduct]
        isLeft = true
      }
      tempProductGroup.push(prevLastGroupProduct)
    }
    else if (_tempProduct && prevLastPos) { // 是sceneImage && 上一个最后一组数据非单数
      if (isLeft) {
        tempProductGroup.push([_tempProduct, newProd])
        isLeft = false
      }
      else {
        tempProductGroup.push([newProd, _tempProduct])
        isLeft = true
      }
    }
    else if (!_tempProduct && !prevLastPos) {
      tempProductGroup[tempProductGroup.length - 1][1] = newProd
    }
    else {
      tempProductGroup.push([newProd, null])
    }
  })
  const renderList = []
  tempProductGroup.forEach((temp, index) => {
    temp[0]._originIndex = 0
    temp[0]._showSummary = temp[1] && !temp[1].copywriter && !temp[0].copywriter
    renderList.push(temp[0])
    if (temp[1]) {
      temp[1]._originIndex = 1
      temp[1]._showSummary = !temp[0].copywriter && !temp[1].copywriter
      renderList.push(temp[1])
    }
  })

  if (singleProduct) {
    singleProduct._originIndex = 1
    renderList.unshift(singleProduct)
  }

  return {
    items: tempProductGroup,
    renderList,
    // singleProduct
  }
}

function formatZipListImage (src, width){
  if (src.includes('x-oss-process')) {
    return src
  }
  return `${src}?x-oss-process=image/quality,q_90`
}

function formatZipImage (src, width) {
  const stuffIndex = src.lastIndexOf('.')
  const stuff = src.substring(stuffIndex)
  const stuffStr = stuff.toLowerCase()

  if(stuffStr == ".jpg" || stuffStr == ".jpeg" || stuffStr == ".png" || stuffStr == ".webp") {
    return `${src}@0o_0l_${width}w_90q`
  } else if (stuffStr == ".gif") {
    return `${src}?x-oss-process=image/resize,w_${width}/quality,q_90`
  } else {
    return src
  }
}





// WEBPACK FOOTER //
// ./static/util/index.js